import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ErrorUtil} from "../../../../../util/error";
import {Snackbar} from "../../../../../util/snackbar";
import {HttpErrorResponse} from "@angular/common/http";
import {CompanyNotesProvider} from "../../../../../providers/company/company/company-notes";

@Component({
  selector: 'app-deletar-anotacao',
  templateUrl: './deletar-anotacao.component.html',
  styleUrls: ['./deletar-anotacao.component.scss']
})
export class DeletarAnotacaoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeletarAnotacaoComponent>,
              public provider: CompanyNotesProvider,
              public errorUtil: ErrorUtil,
              public  snackbar: Snackbar,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close("cancelou");
  }

  onYesClick(): void {
    this.provider.delete(this.data.id).then(() => {
      this.dialogRef.close(this.data);
      this.snackbar.openLong('Excluído com sucesso!', 'success');
    }).catch((reason: HttpErrorResponse) => {
      this.snackbar.openLong('Não foi possível excluir! ' + this.errorUtil.checkErrorStatus(reason, reason.status, reason.error, 'grouper'), 'erro');
    })
    ;
  }
}
